/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactpackanchorus3Inputs */

const en_artifactpackanchorus3 = /** @type {(inputs: Artifactpackanchorus3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ClaimPack — €149, downloadable in under a minute`)
};

const pt_artifactpackanchorus3 = /** @type {(inputs: Artifactpackanchorus3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ClaimPack — €149, transferível em menos de um minuto`)
};

/**
* | output |
* | --- |
* | "ClaimPack — €149, downloadable in under a minute" |
*
* @param {Artifactpackanchorus3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactpackanchorus3 = /** @type {((inputs?: Artifactpackanchorus3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactpackanchorus3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactpackanchorus3(inputs)
	return pt_artifactpackanchorus3(inputs)
});
export { artifactpackanchorus3 as "artifactPackAnchorUs" }